import React from "react";
import { Box, SpaceBetween, Badge } from "@cloudscape-design/components";
import { BadgeColor } from "src/constants/reportConstants";

interface BadgeSectionProps {
  title: string;
  items: string[];
  direction?: "horizontal" | "vertical";
  badgeColor?: BadgeColor;
}

/**
 * Reusable component for displaying a collection of badges with a title
 * @param title - Section title
 * @param items - Array of items to display as badges
 * @param direction - Layout direction for badges
 * @param badgeColor - Color variant for badges
 */
export const BadgeSection: React.FC<BadgeSectionProps> = ({ 
  title, 
  items, 
  direction = "horizontal",
  badgeColor = BadgeColor.SEVERITY_NEUTRAL
}) => (
  <Box>
    <Box variant="h3" margin={{ bottom: "s" }}>{title}</Box>
    <SpaceBetween direction={direction} size="xs">
      {items.map((item, index) => (
        <Badge key={index} color={badgeColor}>
          {item}
        </Badge>
      ))}
    </SpaceBetween>
  </Box>
);
